export type Countries = Record<string, string>

export const countriesEng: Countries = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Democratic Republic of the Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Côte d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  PF: 'French Polynesia',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  HT: 'Haiti',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Republic of Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Republic of Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  SS: 'South Sudan',
  ES: 'España',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  VI: 'Virgin Islands',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

export function getCountryName(isoCode: string | null | undefined): string {
  if (!isoCode) return '-'
  return countries[isoCode] || isoCode
}

export const countries: Countries = {
  AF: 'Afganistán',
  AL: 'Albania',
  DZ: 'Argelia',
  AS: 'Samoa Americana',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguila',
  AG: 'Antigua y Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaiyán',
  BS: 'Bahamas',
  BH: 'Bahréin',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Bielorrusia',
  BE: 'Bélgica',
  BZ: 'Belice',
  BJ: 'Benín',
  BM: 'Bermudas',
  BT: 'Bután',
  BO: 'Bolivia, Estado Plurinacional de',
  BA: 'Bosnia y Herzegovina',
  BW: 'Botswana',
  BR: 'Brasil',
  IO: 'Territorio Británico del Océano Índico',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Camboya',
  CM: 'Camerún',
  CA: 'Canadá',
  CV: 'Cabo Verde',
  KY: 'Islas Caimán',
  CF: 'República Centroafricana',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoras',
  CG: 'Congo',
  CD: 'República Democrática del Congo',
  CK: 'Islas Cook',
  CR: 'Costa Rica',
  CI: 'Costa de Marfil',
  HR: 'Croacia',
  CU: 'Cuba',
  CW: 'Curazao',
  CY: 'Chipre',
  CZ: 'República Checa',
  DK: 'Dinamarca',
  DJ: 'Yibuti',
  DM: 'Dominica',
  DO: 'República Dominicana',
  EC: 'Ecuador',
  EG: 'Egipto',
  SV: 'El Salvador',
  GQ: 'Guinea Ecuatorial',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Etiopía',
  FK: 'Islas Malvinas (Falkland)',
  FO: 'Islas Feroe',
  FJ: 'Fiyi',
  FI: 'Finlandia',
  FR: 'Francia',
  PF: 'Polinesia Francesa',
  GA: 'Gabón',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Alemania',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Grecia',
  GL: 'Groenlandia',
  GD: 'Granada',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernesey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  HT: 'Haití',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungría',
  IS: 'Islandia',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Irán, República Islámica de',
  IQ: 'Irak',
  IE: 'Irlanda',
  IM: 'Isla de Man',
  IL: 'Israel',
  IT: 'Italia',
  JM: 'Jamaica',
  JP: 'Japón',
  JE: 'Jersey',
  JO: 'Jordania',
  KZ: 'Kazajstán',
  KE: 'Kenia',
  KI: 'Kiribati',
  KP: 'Corea del Norte',
  KR: 'Corea del Sur',
  KW: 'Kuwait',
  KG: 'Kirguistán',
  LA: 'República Democrática Popular Lao',
  LV: 'Letonia',
  LB: 'Líbano',
  LS: 'Lesoto',
  LR: 'Liberia',
  LY: 'Libia',
  LI: 'Liechtenstein',
  LT: 'Lituania',
  LU: 'Luxemburgo',
  MO: 'Macao',
  MK: 'República de Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malasia',
  MV: 'Maldivas',
  ML: 'Malí',
  MT: 'Malta',
  MH: 'Islas Marshall',
  MQ: 'Martinica',
  MR: 'Mauritania',
  MU: 'Mauricio',
  MX: 'México',
  FM: 'Micronesia, Estados Federados de',
  MD: 'República de Moldavia',
  MC: 'Mónaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marruecos',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Países Bajos',
  NZ: 'Nueva Zelanda',
  NI: 'Nicaragua',
  NE: 'Níger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Isla Norfolk',
  MP: 'Islas Marianas del Norte',
  NO: 'Noruega',
  OM: 'Omán',
  PK: 'Pakistán',
  PW: 'Palaos',
  PS: 'Territorio palestino',
  PA: 'Panamá',
  PG: 'Papua Nueva Guinea',
  PY: 'Paraguay',
  PE: 'Perú',
  PH: 'Filipinas',
  PN: 'Pitcairn',
  PL: 'Polonia',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RO: 'Rumania',
  RU: 'Rusia',
  RW: 'Ruanda',
  KN: 'San Cristóbal y Nieves',
  LC: 'Santa Lucía',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Santo Tomé y Príncipe',
  SA: 'Arabia Saudita',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leona',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SK: 'Eslovaquia',
  SI: 'Eslovenia',
  SB: 'Islas Salomón',
  SO: 'Somalia',
  ZA: 'Sudáfrica',
  SS: 'Sudán del Sur',
  ES: 'España',
  LK: 'Sri Lanka',
  SD: 'Sudán',
  SR: 'Surinam',
  SZ: 'Suazilandia',
  SE: 'Suecia',
  CH: 'Suiza',
  SY: 'Siria',
  TW: 'Taiwán',
  TJ: 'Tayikistán',
  TZ: 'Tanzania',
  TH: 'Tailandia',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad y Tobago',
  TN: 'Túnez',
  TR: 'Turquía',
  TM: 'Turkmenistán',
  TC: 'Islas Turcas y Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ucrania',
  AE: 'Emiratos Árabes Unidos',
  GB: 'Reino Unido',
  US: 'Estados Unidos',
  UY: 'Uruguay',
  UZ: 'Uzbekistán',
  VU: 'Vanuatu',
  VE: 'Venezuela, República Bolivariana de',
  VN: 'Vietnam',
  VI: 'Islas Vírgenes',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabue',
}
